import { DEMAND_TYPES } from "@core/constants";
import { CreationDemandModel, DemandRecapModel, ICreationDemand, IDemandRecap, IOutfitColor, OutfitColorModel } from "@core/models";

// CDI
export const basicCreationDemandCDIMock = new CreationDemandModel({
  [ICreationDemand.type]: DEMAND_TYPES.CDI,
});

export const basicDemandRecapMock = new DemandRecapModel({
  [IDemandRecap.priceHT]: "95",
  [IDemandRecap.priceTTC]: "114.00",
  [IDemandRecap.demandType]: "CDI",
  [IDemandRecap.demandQualification]: "Serveur",
});

// AE
export const basicCreationDemandAEMock = new CreationDemandModel({
  [ICreationDemand.type]: DEMAND_TYPES.AE,
  [ICreationDemand.numberOfExtra]: 4,
});

export const outfitColorsMock = [
  {
    [IOutfitColor.id]: 5,
    [IOutfitColor.label]: "Jean Brut",
    [IOutfitColor.code]: "linear-gradient(to top, rgba(56, 107, 162, 0.77), rgb(7, 44, 85))",
    [IOutfitColor.autoselected]: false,
  },
  {
    [IOutfitColor.id]: 6,
    [IOutfitColor.label]: "Blanc",
    [IOutfitColor.code]: "rgb(255, 255, 255)",
    [IOutfitColor.autoselected]: false,
  },
  {
    [IOutfitColor.id]: 7,
    [IOutfitColor.label]: "Noir",
    [IOutfitColor.code]: "rgb(0, 0, 0)",
    [IOutfitColor.autoselected]: false,
  },
].map((color) => new OutfitColorModel(color));
